'use client';
import { useEffect } from 'react';
import i18n from '@/i18n';

const HTML_LANG_BY_LANG: Record<string, string> = {
  de: 'de',
  es: 'es',
  fr: 'fr',
  it: 'it',
  pt: 'pt-BR',
  sr: 'sr-Latn-RS',
  nl: 'nl',
  ja: 'ja',
  pl: 'pl',
};

function htmlLang(lang: string) {
  return HTML_LANG_BY_LANG[lang] || 'en';
}

export default function LangInitializer({ lang }: { lang: string }) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = htmlLang(lang);
  }

  if (i18n.language !== lang) {
    i18n.changeLanguage(lang);
  }

  useEffect(() => {
    document.documentElement.lang = htmlLang(lang);
    // Always call changeLanguage so Header/LangSwitcher listeners fire
    // even when the page language happens to be the same as the default.
    i18n.changeLanguage(lang);
  }, [lang]);

  return null;
}
